/* eslint-disable no-underscore-dangle */ function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export var EVENTS = '__events__';
export var SHARED = '__shared__';
export var OBSERVERS = '__observers__';
var localWindow = window;
export var WindowedObservable = /*#__PURE__*/ function() {
    "use strict";
    function WindowedObservable(namespace) {
        _class_call_check(this, WindowedObservable);
        _define_property(this, "_namespace", void 0);
        _define_property(this, "dispatch", this.publish);
        WindowedObservable.initialize();
        this.namespace = namespace;
    }
    _create_class(WindowedObservable, [
        {
            key: "namespace",
            set: function set(namespace) {
                this._namespace = btoa(namespace).replace(/[^\w\s]/gi, '').replace(/[0-9]/g, '');
                // istanbul ignore next
                if (!this.events) this.events = [];
                // istanbul ignore next
                if (!this.observers) this.observers = [];
            }
        },
        {
            key: "events",
            get: function get() {
                return localWindow[SHARED][EVENTS][this._namespace];
            },
            set: function set(newEvents) {
                localWindow[SHARED][EVENTS][this._namespace] = newEvents;
            }
        },
        {
            key: "observers",
            get: function get() {
                return localWindow[SHARED][OBSERVERS][this._namespace];
            },
            set: function set(newObservers) {
                localWindow[SHARED][OBSERVERS][this._namespace] = newObservers;
            }
        },
        {
            key: "getEvents",
            value: function getEvents() {
                return this.events;
            }
        },
        {
            key: "getLastEvent",
            value: function getLastEvent() {
                var events = this.events;
                if (!events.length) {
                    return undefined;
                }
                return events[events.length - 1]().get(this._namespace);
            }
        },
        {
            key: "publish",
            value: function publish(data) {
                var _this = this;
                var events = this.events;
                var lastEvent = this.getLastEvent();
                this.observers.forEach(function(observer) {
                    return observer(data, {
                        events: events,
                        lastEvent: lastEvent
                    });
                });
                this.events.push(function() {
                    var accessKey = _this._namespace;
                    return {
                        get: function(key) {
                            if (key === accessKey) {
                                return data;
                            }
                            throw new Error('No Access');
                        }
                    };
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(observer) {
                this.observers = this.observers.concat(observer);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(observer) {
                this.observers = this.observers.filter(function(obs) {
                    return obs !== observer;
                });
            }
        },
        {
            key: "clear",
            value: function clear() {
                var events = this.events;
                var lastEvent = this.getLastEvent();
                this.observers.forEach(function(observer) {
                    return observer(undefined, {
                        events: events,
                        lastEvent: lastEvent
                    });
                });
                this.events = [];
                this.observers = [];
            }
        }
    ], [
        {
            key: "initialize",
            value: // istanbul ignore next
            function initialize() {
                if (!localWindow[SHARED]) {
                    var _obj;
                    localWindow[SHARED] = (_obj = {}, _define_property(_obj, EVENTS, {}), _define_property(_obj, OBSERVERS, {}), _obj);
                }
                if (!localWindow[SHARED][EVENTS]) {
                    localWindow[SHARED][EVENTS] = {};
                }
                if (!localWindow[SHARED][OBSERVERS]) {
                    localWindow[SHARED][OBSERVERS] = {};
                }
            }
        }
    ]);
    return WindowedObservable;
}();
